module.exports = __webpack_public_path__ + "img/arch-inf-sel.1ef2a099.svg";